import * as Rox from "rox-browser";

export const financial_documents = {
    analytics__download_documents: new Rox.Flag(),
    filter_by_jobsite: new Rox.Flag(),
    extra_services: new Rox.Flag(),
    load_timeStamps: new Rox.Flag(),
    v2: new Rox.Flag(),
};
